import React, { useEffect, useRef, useState } from 'react';
import { Box } from '@mui/material';
import Lottie from 'lottie-react';

type Props = {
    fileName: string,
    segments: { frames: number[] }[],
    delay?: number
}

export const LottieAnimation = ({ fileName, segments, delay = 0 }: Props): JSX.Element => {

    const lottieRef = useRef();
    const [animation, setAnimation] = useState(null);
    const [currentSegment, setCurrentSegment] = useState(0);

    const onDOMLoaded = () => {
        setTimeout(() => {
            playSegement(0);
        }, delay);
    };

    const playSegement = (segmentIndex: number) => {
        setCurrentSegment(segmentIndex);
        const segment = segments[0];

        const ref = lottieRef.current || {};
        ref['playSegments'](segment.frames, true);
    };

    const onComplete = () => {
        const segment = segments[currentSegment + 1];
        if (segment) playSegement(currentSegment + 1);
    };

    useEffect(() => {
        import(`./lottie/${fileName}`).then((animation) => {
            setAnimation(animation.default);
        });
    }, [lottieRef]);

    return (
        <Box style={{ width: '100%', height: '100%' }}>
            <Lottie
                height={''}
                lottieRef={lottieRef}
                autoplay={false}
                animationData={animation}
                loop={false}
                onDOMLoaded={onDOMLoaded}
                onComplete={onComplete}
            />
        </Box>
    );
};

export default LottieAnimation;